import {NotificationManager} from 'react-notifications';
export const successMessage = (msg, title="Success") => {
    NotificationManager.success(msg, title);
}

export const errorMessage = (msg, title="Error") => {
    NotificationManager.error(msg, title);
}